module.exports = __webpack_public_path__ + "static/media/course9.ffeb5dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/course9.png
// module id = 2848
// module chunks = 0